import { Authenticator } from '@aws-amplify/ui-react';
import { AuthProvider } from '@saltus/auth';
import { useDispatch } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ContactRouter from '../contact-router/container';
import RedirectRouter from '../redirect-router/container';
import DocumentsRouter from '../documents-router/container';
import ActionApprovalDocRouter from '../actionapprovaldoc-router/container';
import App from '../app/container';
import { getContact, getProfessionalContact } from '../../graphql/queries';
import amplifyInit from '../../services/amplifyInit';
import api from '../../services/api';
import apiService from '../../services/api-service';
import debug from '../../services/debug';
import ScrollToTop from '../scroll-to-top/component';
import reset from '../../actions/store/reset';

const { config, cookieStorage } = amplifyInit();

function AppProvider() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onForgotPassword = async (email) => {
    try {
      await apiService.post(
        import.meta.env.VITE_APP_SALTUS_PORTAL_ACTIVATION_CHECKER_API_URL,
        {
          email,
        },
      );
    } catch (err) {
      debug(err);
    }
  };

  const onGetUserData = async (user) => {
    if (user.groups.find((group) => group === 'Adviser')) {
      const { data } = await api.graphql({
        query: getProfessionalContact,
        variables: {
          ProfessionalContactID: user.attributes.sub,
        },
      });

      return data?.getProfessionalContact;
    }

    const { data } = await api.graphql({
      query: getContact,
      variables: {
        ContactID: user.attributes.sub,
      },
    });

    return data?.getContact;
  };

  const onPasswordSet = () => {};

  const onSignOut = async () => {
    dispatch(reset());

    if (window.ReactNativeWebView !== undefined) {
      window.ReactNativeWebView.postMessage('signedout');
    }

    navigate('/');
  };

  return (
    <Authenticator.Provider>
      <AuthProvider
        config={config}
        keyValueStorage={cookieStorage}
        onForgotPassword={onForgotPassword}
        onGetUserData={onGetUserData}
        onPasswordSet={onPasswordSet}
        onSignOut={onSignOut}
      >
        <Routes>
          <Route path="*" element={<App />} />
          <Route path="/clients/:ContactID" element={<ContactRouter />} />
          <Route
            path="/action/redirect/:command"
            element={<RedirectRouter />}
          />
          {/* TODO: Remove /viewdocuments route */}
          <Route path="/viewdocuments" element={<DocumentsRouter />} />
          <Route
            path="/actionapprovaldoc/:ActionApprovalDocID"
            element={<ActionApprovalDocRouter />}
          />
        </Routes>

        <ScrollToTop />
      </AuthProvider>
    </Authenticator.Provider>
  );
}

export default AppProvider;
